import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-purple-900/20 to-black">
        <img
          src="/images/tom-briskey-HM3WZ4B1gvM-unsplash.webp"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-20"
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />
      </div>
      
      {/* Animated background elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-72 h-72 bg-toxic-green/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-toxic-pink/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 mb-6 px-4 py-2 glass rounded-full border border-toxic-green/30">
          <Sparkles className="w-4 h-4 text-toxic-green" />
          <span className="text-sm text-toxic-green">Comparateur indépendant de sites de paris</span>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
          <span className="bg-gradient-to-r from-toxic-green via-toxic-cyan to-toxic-pink bg-clip-text text-transparent">
            Trouvez le meilleur
          </span>
          <br />
          <span className="text-white">site de paris pour vous</span>
        </h1>
        
        <p className="text-xl md:text-2xl text-white/70 mb-8 max-w-3xl mx-auto">
          Comparez les bonus, les cotes et les fonctionnalités des meilleurs opérateurs agréés en France. 
          Maximisez vos gains dès votre premier pari.
        </p>
        
       
        
        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          <a
            href="#offers"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('offers')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-4 py-2 glass border border-toxic-green/30 text-white text-sm font-semibold rounded-lg hover:border-toxic-green hover:bg-toxic-green/10 transition-all"
          >
            Offres
          </a>
          <a
            href="#about"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-4 py-2 glass border border-toxic-pink/30 text-white text-sm font-semibold rounded-lg hover:border-toxic-pink hover:bg-toxic-pink/10 transition-all"
          >
            À propos
          </a>
          <a
            href="#guides"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('guides')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-4 py-2 glass border border-toxic-cyan/30 text-white text-sm font-semibold rounded-lg hover:border-toxic-cyan hover:bg-toxic-cyan/10 transition-all"
          >
            Guides
          </a>
          <a
            href="#faq"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-4 py-2 glass border border-toxic-yellow/30 text-white text-sm font-semibold rounded-lg hover:border-toxic-yellow hover:bg-toxic-yellow/10 transition-all"
          >
            FAQ
          </a>
          <a
            href="#news"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('news')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-4 py-2 glass border border-toxic-orange/30 text-white text-sm font-semibold rounded-lg hover:border-toxic-orange hover:bg-toxic-orange/10 transition-all"
          >
            Actualités
          </a>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-4 py-2 glass border border-toxic-green/30 text-white text-sm font-semibold rounded-lg hover:border-toxic-green hover:bg-toxic-green/10 transition-all"
          >
            Contact
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;

